// ─── AGU SUI Contract Constants ──────────────────────────────────────────
// Mainnet deployment: 2026-02-21
// TX: 417odr6Wjy8L54BYtM6oZooPZhEZQRae9iPkZcbbJA2s

export const SUI_NETWORK = 'mainnet' as const;
export const SUI_RPC_URL = 'https://fullnode.mainnet.sui.io:443';

// ─── Package ─────────────────────────────────────────────────────────────
export const PACKAGE_ID = '0xca27fdb22fd1c6c8ac56de28552e51cf769bf0f61f11f3c9dc25d44c9c18b22a';

// ─── AGU Token Type ──────────────────────────────────────────────────────
export const AGU_TOKEN_TYPE = `${PACKAGE_ID}::agu_token::AGU_TOKEN` as const;
export const AGU_COIN_TYPE = `0x2::coin::Coin<${AGU_TOKEN_TYPE}>` as const;
export const AGU_DECIMALS = 9;

// ─── Shared Objects ──────────────────────────────────────────────────────
export const OBJECTS = {
  treasuryCap: '0x285b894b936e5d6da030839dd3c8f116f6ec08464bd627ca501c88cd5470ff2a',
  coinMetadata: '0xe2d72b67fa92a895a0326bb3d157c08e9d9a3d9595671491743b4d05beb48d4d',
  aguTreasury: '0x10cdb57e77976ce0021dc4e5317d0747fdbed3e219354820438a74c73a0c83b5',
  stakingPool: '0x414654a0be4b5617b8c7d0f626c494de51bafb60e023b25b98eabc4519eb86a8',
  governanceConfig: '0x63d58c255110cf454d7751eb01c9ca47223716f3debc997b069a6811c228679e',
  marketConfig: '0x9845b179e32b3dd1273733b9f39c29411c6c0a36e438e601b783dbbaae10ef8f',
  insurancePool: '0xedb2df1672b89098e3eefea0ec9f6ff5a57c4fd68bc54f66254b08530aec494a',
  agentRegistry: '0x8a83edbaa80955c43568710c5bb049f0bebe2ef32a18e7ac3dffc0d7ddc6b5fa',
  settlementTreasury: '0xe22a5f94f6b568da7c85002f5227e1e67de2369c40e284a612e80b634d3b22d2',
} as const;

// ─── Capability Objects (Deployer: 0xaaeca6cb...) ────────────────────────
export const CAPS = {
  superAdmin: '0xd6d2179f77b4617184449d90ff6de431039c008c605feddb274519d8cc485fbf',
  governance: '0x006d70147c422c4bbb1f2a883e94f4ba447b048987c2dd16024f6c42f9ee8430',
  treasuryManager: '0xc8bb5a2bb0a93e0a6e73984619a484bde18025c659d2b61b841b72860292833e',
  stakingManager: '0xe3a41ab77de1bfa25cdba401e3d670c5d8c9b0375d56729baeb7abfffeaaca2a',
  marketAdmin: '0xf89d76d0d7decf6a28d3ea277f9476e5e7fe13e27e6b97b2c7b116e006d64305',
  insuranceAdmin: '0x82be0e5fa451b48deaf465e07fce2f5a7d842866a89d64adc5c984085a1cde98',
  settlementAdmin: '0x1c5c5e22c0d28e035763f7ee5df9a6e64e31359558362e7bdf45fb2877955c49',
  upgradeCap: '0xc0e91572115d68549f3dab1d673bae2c863e6bc81c0d63feefe966a312c31a57',
} as const;

// ─── Explorer URLs ───────────────────────────────────────────────────────
export const explorerUrl = (type: 'object' | 'tx' | 'address', id: string) =>
  `https://suiscan.xyz/mainnet/${type}/${id}`;

// ─── Helper: format AGU amount (u64 → human readable) ────────────────────
export const formatAGU = (raw: bigint | string | number): string => {
  const val = Number(BigInt(raw)) / 10 ** AGU_DECIMALS;
  return val.toLocaleString(undefined, { maximumFractionDigits: 4 });
};

export const parseAGU = (human: number): bigint =>
  BigInt(Math.floor(human * 10 ** AGU_DECIMALS));
